import { RECIPE_IMAGEFLUX_BASE_URL_MAP } from '@shared/app/constants/imagefluxBaseUrlMap';
import type { AppEnv } from '@shared/app/types/AppEnv';
import { createImageFluxUrl } from '@shared/app/utils/createImageFluxUrl';
import {
  createRecipeCandidateImageKey,
  createRecipeMainImageKey,
} from '@shared/app/utils/createRecipeS3ImageKey';
import { useRuntimeConfig } from '#imports';

export function useRecipeImageUrl() {
  const APP_ENV = useRuntimeConfig().public.APP_ENV as AppEnv;

  const imageFluxBaseUrl = (() => {
    switch (APP_ENV) {
      case 'production':
        return RECIPE_IMAGEFLUX_BASE_URL_MAP.production;
      case 'staging':
        return RECIPE_IMAGEFLUX_BASE_URL_MAP.staging;
      default:
        return RECIPE_IMAGEFLUX_BASE_URL_MAP.local;
    }
  })();

  function createRecipeMainImageUrl({
    w,
    h,
    filename,
    recipeId,
  }: {
    w?: number;
    h?: number;
    filename: string;
    recipeId: number;
  }) {
    const path = createRecipeMainImageKey(recipeId, filename);
    return createImageFluxUrl(imageFluxBaseUrl, { w, h, path });
  }

  function createRecipeCandidateImageUrl({
    w,
    h,
    filename,
    candidateImageId,
  }: {
    w?: number;
    h?: number;
    filename: string;
    candidateImageId: number;
  }) {
    const path = createRecipeCandidateImageKey(candidateImageId, filename);
    return createImageFluxUrl(imageFluxBaseUrl, { w, h, path });
  }

  return {
    createRecipeMainImageUrl,
    createRecipeCandidateImageUrl,
  };
}
